import { gql } from 'graphql-tag';

const createOrUpdateLocationContactMutation = gql`
  mutation CreateOrUpdateLocationContact(
    $locationContact: LocationContactInputObjectType!
  ) {
    createOrUpdateLocationContact(
      input: { locationContact: $locationContact }
    ) {
      success
      errors
      msg
    }
  }
`;

export default createOrUpdateLocationContactMutation;
